import { isTokenExpired } from './token';

const PROTECTED_ROUTES = ['/profile', '/saved-deals'];

export const isProtectedRoute = (pathname: string): boolean =>
  PROTECTED_ROUTES.includes(pathname);

export const shouldRestoreSession = (
  accessToken: string | undefined,
  refreshToken: string | undefined
): boolean =>
  Boolean(refreshToken) && (!accessToken || isTokenExpired(accessToken));
